import { AsyncStatus } from 'utils/asyncStatusHelper';
import { EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE } from 'actions/PaymentActions/PaymentActions';

export const INITIAL_STATE = {};

export default function emiOnSavedCards(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.REQUEST:
			return {
				...state,
				[action.key]: { asyncStatus: AsyncStatus.LOADING }
			};
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.SUCCESS:
			return {
				...state,
				[action.key]: { ...action.data, asyncStatus: AsyncStatus.SUCCESS }
			};
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.ERROR:
			const finalData = Object.assign({}, state[action.key], { error: action.error, asyncStatus: AsyncStatus.ERROR });

			return {
				...state,
				[action.key]: finalData
			};
		case EMI_ON_SAVED_CARDS_TENURES_ACTION_STATE.RESET:
			return {
				...state,
				[action.key]: { asyncStatus: AsyncStatus.INIT }
			};
		default:
			return state;
	}
}
